import { ApiRoutes } from "@futgg/core";
var JS_TRIGGER_SELECTOR = ".js-trigger-gga-event";
export function ggaInit() {
    var ggaEls = Array.from(document.querySelectorAll(JS_TRIGGER_SELECTOR));
    window.addEventListener("load", function () {
        if (ggaEls.length > 0) {
            ggaEls.forEach(function (ggaEl) {
                var entity_id = ggaEl.dataset.entityId;
                var entity_name = ggaEl.dataset.entityName;
                if (entity_id && entity_name) {
                    fetch(ApiRoutes.ggaTrackPageview(entity_name, entity_id));
                }
            });
        }
    });
}
